<template>
  <div>
    <v-card class="crud-dialog">
      <v-card-title class="headline">
        <v-icon>security</v-icon> N° de Solicitud: {{ tramite.id }}
        <div class="tramite-estado">
          <v-chip label :color="'info'" v-if="tramite.documento_derivar === 'CANCILLERIA'" text-color="white">
            <small>ENVIADO DESDE SERVICIO WEB</small>
          </v-chip>
          <v-chip label :color="estados[tramite.estado]" text-color="white">
            <small>{{ tramite.estado ? tramite.estado.replace(/_/gi, ' ') : '' }}</small>
          </v-chip>
        </div>
        <v-btn icon @click.native="cerrar_ventana">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs4 v-show="detalles">
            <detalle-doc :solicitud="tramite" :pagos="pagos"></detalle-doc>
          </v-flex>
          <v-flex xs8 :class="{ xs12: !detalles }">
            <v-card-actions class="margin-0 p-l-0 p-r-0 p-t-0">
              <v-tooltip top class="margin-0">
                <v-btn
                  type="button"
                  slot="activator"
                  class="margin-0"
                  @click="detalles = !detalles">
                  <v-icon>{{ detalles ? 'chevron_left' : 'chevron_right' }}</v-icon>
                  {{ detalles ? 'Ocultar' : 'Mostrar' }}
                </v-btn>
                <span>{{ detalles ? 'Ocultar' : 'Mostrar' }} detalles</span>
              </v-tooltip>
              <v-spacer></v-spacer>
              <v-tooltip top>
                <v-btn
                  type="button"
                  slot="activator"
                  class="margin-0"
                  v-show="tramite.id_archivo > 1"
                  @click="cambiarDoc()">
                  <v-icon>swap_horiz</v-icon>
                  Cambiar
                </v-btn>
                <span>Cambiar por otro documento</span>
              </v-tooltip>
              <v-btn
                type="button"
                class="margin-0"
                v-show="tramite.id_archivo == 1 && $store.state.archivo > 1"
                @click="cancelarCambio()">
                <v-icon>cancel</v-icon>
                Cancelar cambio
              </v-btn>
              <v-tooltip top>
                <v-btn
                  color="error"
                  slot="activator"
                  class="margin-0"
                  v-if="$store.state.permissions['tramitesDoc:update'] && tramite.estado != 'OBSERVADO_ENTIDAD_REVISOR'"
                  @click.native="openObservar(solicitud)">
                  <v-icon>warning</v-icon> OBSERVAR
                </v-btn>
                <span>Observar documento</span>
              </v-tooltip>
              <v-btn
                class="m-r-0"
                v-if="$store.state.user.id_rol === 6 && tramite.id_archivo != null && tramite.estado != 'OBSERVADO_ENTIDAD_REVISOR'"
                color="primary"
                :disabled="tramite.id_archivo == 1"
                @click="aprobarEntidad(tramite);">
                <v-icon>check</v-icon> Enviar para firma (Entidad)
              </v-btn>
              <!--<v-btn
                class="m-r-0"
                v-if="$store.state.user.id_rol === 3 && tramite.id_archivo != null && tramite.estado != 'OBSERVADO_ENTIDAD_REVISOR'"
                color="info"
                :disabled="tramite.id_archivo == 1 || tramite.pago_cancilleria"
                @click="generarCptCancilleria(tramite)">
                <v-icon>monetization_on</v-icon> Habilitar Pago
              </v-btn>-->
              <v-btn
                class="m-r-0"
                v-if="$store.state.user.id_rol === 3 && tramite.id_archivo != null && tramite.estado != 'OBSERVADO_ENTIDAD_REVISOR' && pdfValido === true"
                color="primary"
                :disabled="tramite.id_archivo == 1"
                @click="aprobarCancilleria(tramite);">
                <v-icon>check</v-icon> Enviar para firma
              </v-btn>
            </v-card-actions>
            <v-layout row wrap v-if="($store.state.user.id_rol === 4 || $store.state.user.id_rol === 3) && solicitud.firmante && solicitud.firmante.firmante_nombre_completo" class="firma-detalle">
              <v-flex xs6>
                <h5>Datos del usuario</h5>
                <strong>Nombre:</strong> {{ solicitud.firmante.firmante_nombre_completo }} <br />
                <strong>Cargo:</strong> {{ solicitud.firmante.firmante_cargo ||'[no registrado]' }} <br />
                <strong>Entidad:</strong> {{ solicitud.firmante.entidad_nombre }}<br>
                <strong>Departamento:</strong> {{ solicitud.firmante.firmante_departamento.split(',').join(', ') }}
              </v-flex>
              <v-flex xs6 v-if="solicitud.firmante.certicado_token">
                <h5>Datos firma en documento</h5>
                <strong>Nombre:</strong> {{ solicitud.firmante.certicado_token.nombreComunSubject }} <br />
                <strong>Certificado por:</strong> {{ solicitud.firmante.certicado_token.nombreComunIssuer }} <br />
                <strong>Fecha inicio validez:</strong> {{ solicitud.firmante.certicado_token.inicioValidez}} <br />
                <strong>Fecha fin validez:</strong> {{ solicitud.firmante.certicado_token.finValidez }} <br />
                <!--<strong>Cargo:</strong> {{ solicitud.firmante.certicado_token.unidadOrganizacionalSubject }} <br />-->
                <!--<strong>Entidad:</strong> {{ solicitud.firmante.certicado_token.organizacionSubject }}-->

              </v-flex>
            </v-layout>
            <div v-if="$store.state.user.id_rol === 6 || $store.state.user.id_rol === 3">
              <file-upload
                :url="url"
                v-if="tramite.id_archivo == 1"
                :max-filesize="$store.state.maxFilesize"
                label="Arrastre aquí el documento o haga clic aquí para adjuntar el documento PDF para apostillar">
              </file-upload>
            </div>
            <div class="pdf-container">
              <!-- {{solicitud.pdfValido}} <br>
              {{tramite.id_archivo}} -->
              <!-- <v-alert color="warning" icon="warning" value="solicitud.pdfValido" > -->
              <v-alert color="warning" icon="warning" value="true" v-if="pdfValido == false && tramite.id_archivo > 1">
                El documento PDF, no es válido o se encuentra corrupto.
              </v-alert>
              <pdf-view :data="pdf" :url="urlPdf" v-bind:valido="validarPdf" v-if="pdf && tramite.id_archivo > 1"></pdf-view>
              <v-alert
                color="warning"
                icon="warning"
                v-if="solicitud.estado.indexOf('OBSERVADO') != -1 && tramite.id_archivo == 1"
                value="true">
                La solicitud no cuenta con un documento PDF adjunto
              </v-alert>
            </div>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-dialog v-model="$store.state.modal5" max-width="480">
      <observar :solicitud="solicitud" v-if="solicitud"></observar>
    </v-dialog>
  </div>
</template>

<script>
import FileUpload from '@/common/util/FileUpload.vue';
import Observar from './Observar.vue';
import tramiteDoc from './mixins/tramite_doc';
import DetalleDoc from './DetalleDoc';
import PdfView from '@/common/util/pdf/PdfView';

const estados = {
  CREADO: 'success',
  REVISADO_ENTIDAD: 'info',
  OBSERVADO_ENTIDAD_REVISOR: 'warning',
  OBSERVADO_ENTIDAD_FIRMANTE: 'warning',
  FIRMADO_ENTIDAD: 'success',
  REVISADO_CANCILLERIA: 'info',
  OBSERVADO_CANCILLERIA_REVISOR: 'warning',
  OBSERVADO_CANCILLERIA_FIRMANTE: 'warning',
  APOSTILLADO: 'primary'
};

export default {
  props: {
    solicitud: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      estados,
      tramite: {},
      pagos: [],
      pdf: null,
      urlPdf: null,
      detalles: true,
      pdfValido: false
    };
  },
  mixins: [ tramiteDoc ],
  created () {
    this.$store.state.modal5 = false;

    // Cargando tramite
    if (this.solicitud) {
      this.getTramite(this.solicitud.id);
    }
  },
  components: {
    FileUpload,
    Observar,
    DetalleDoc,
    PdfView
  },
  methods: {
    validarPdf (val) {
      if (val === false) this.pdfValido = false;
      else this.pdfValido = true;
    },
    openObservar (item) {
      this.solicitud = item;
      this.$store.commit('openModal', 5);
    },
    cambiarDoc () {
      this.tramite.id_archivo = 1;
    },
    cancelarCambio () {
      this.tramite.id_archivo = this.$store.state.archivo;
    },
    aprobarEntidad (solicitud) {
      if (this.$filter.empty(this.$store.state.date.fecha_inicio)) {
        this.$message.warning('Ingrese la <strong>fecha de inicio</strong> de la vigencia del documento');
        return false;
      }
      if (this.$filter.empty(this.$store.state.date.fecha_fin)) {
        this.$message.warning('Ingrese la <strong>fecha final</strong> de la vigencia del documento');
        return false;
      }
      if (this.$datetime.diff(this.$store.state.date.fecha_fin, this.$store.state.date.fecha_inicio) < 0) {
        this.$message.warning('<strong>Validez del documento</strong>.- La fecha final debe ser mayor a la fecha de inicio');
        return false;
      }
      // this.generarCpt(solicitud, 'ENTIDAD', () => { // La entidad ya no realizará el pago mediante la plataforma de pagos.
      this.actualizarEstadoTramiteDoc(solicitud, 'REVISADO_ENTIDAD');
      // });
    },
    aprobarCancilleria (solicitud) {
      /* if (!solicitud.pago_cancilleria) {
        this.$message.warning('Antes de enviar para firma, el trámite debe haber sido pagado');
        return false;
      } */

      if (solicitud.firmante_documento_nombre && solicitud.firmante_documento_cargo && solicitud.firmante_documento_entidad) {
        this.actualizarEstadoTramiteDoc(solicitud, 'REVISADO_CANCILLERIA');
      } else {
        this.$message.warning(`Debe ingresar todos los datos del Firmante del Documento`);
      }
    },
    generarCptCancilleria (solicitud) {
      this.generarCpt(solicitud, 'CANCILLERIA', () => {
        // this.actualizarEstadoTramiteDoc(solicitud, 'REVISADO_CANCILLERIA');
      });
    },
    cerrar_ventana () {
      this.$store.commit('closeModal', 2);
      document.querySelector('#btn-refresh-list').dispatchEvent(new window.Event('click'));
    }
  },
  watch: {
    '$store.state.archivo': function (val) {
      this.pdf = null;
      this.urlPdf = null;
      this.tramite.id_archivo = val;
      this.url = this.$apiUrl + 'eregister/upload/' + this.tramite.id + '/' + this.tramite.id_archivo;
      this.getPdf(val);
    }
  }
};
</script>

<style src="./tramite.scss" lang="scss"></style>



// WEBPACK FOOTER //
// Revisor.vue?0c37bb85